import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('group', [_c('popup-picker', {
    attrs: {
      "show-name": "",
      "title": i18n.tc("236"),
      "placeholder": i18n.tc("237"),
      "value-text-align": "right",
      "columns": 1,
      "data": _vm.logisticsCompany
    },
    on: {
      "on-change": _vm.getCompany
    },
    model: {
      value: _vm.logistics_company_id,
      callback: function ($$v) {
        _vm.logistics_company_id = $$v;
      },
      expression: "logistics_company_id"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: '9.6rem'
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]), _vm._v(" " + i18n.tc("236") + " ")])])], 1), _c('group', [_c('x-input', {
    attrs: {
      "title": i18n.tc("238"),
      "placeholder": i18n.tc("239"),
      "show-clear": false
    },
    model: {
      value: _vm.form.logistics_num,
      callback: function ($$v) {
        _vm.$set(_vm.form, "logistics_num", $$v);
      },
      expression: "form.logistics_num"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: '9.6rem'
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]), _vm._v(" " + i18n.tc("238") + " ")])])], 1), _c('div', {
    staticClass: "bottom-bar",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('x-button', {
    staticClass: "no-border-radius",
    attrs: {
      "type": "primary",
      "show-loading": _vm.btnLoading,
      "disabled": _vm.btnLoading
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + i18n.tc("240") + " ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };